import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CourseCheckService {
  private http = inject(HttpClient);

  /**
   * Checks if the user has already purchased the course by making an HTTP call
   * to the URL specified in the Heroku setting variable COURSE_CHECK_URL
   * 
   * @param customerEmail - The customer's email address
   * @returns Observable<boolean> - true if user has purchased, false otherwise
   */
  checkCoursePurchase(customerEmail: string): Observable<boolean> {
    // Get the course check URL from Heroku settings
    const courseCheckUrl = (window as any)['process_env']?.COURSE_CHECK_URL;
    const brand = (window as any)['process_env']?.BRAND;
    
    if (!courseCheckUrl) {
      console.warn('COURSE_CHECK_URL not found in Heroku settings. Showing upsell by default.');
      return of(false);
    }
    
    if (!brand) {
      console.warn('BRAND not found in Heroku settings. Showing upsell by default.');
      return of(false);
    }

    if (!customerEmail) {
      console.warn('Customer email not provided. Showing upsell by default.');
      return of(false);
    }

    // Make HTTP call to check if user has purchased the course
    // The API should accept email as a query parameter or in the body
    // Adjust the request format based on your API requirements
    const headers = new HttpHeaders({
      'x-brand': brand,
      'Cache-Control': 'private, no-cache, no-store, must-revalidate, max-age=0',
      'Pragma': 'no-cache',
      'Expires': '0'
    });

    const params = new HttpParams().set('query[email]', customerEmail);

    return this.http.get(`${courseCheckUrl}/users`, {
      params,
      headers,
      observe: 'response'
    }).pipe(
      map((response: any) => {
        // Assuming the API returns a boolean or an object with a hasPurchased field
        // Adjust this based on your actual API response format
        console.log('[GH] Course Check Response body:', response.body);
        
        if (response.body) {
          const payload = typeof response.body === 'string' ? JSON.parse(response.body) : response.body;
          
          const hasPurchased = payload?.success && payload?.data?.items?.length == 1 && payload.data.items[0].email === customerEmail;
          console.log('[GH] Course Check Has purchased result:', hasPurchased);
          
          return hasPurchased;
        }
        
        console.log('[GH] Course Check No response body, returning false');
        return false;
      }),
      catchError((error) => {
        console.error('Error checking course purchase status:', error);
        // On error, show the upsell by default (fail open)
        return of(false);
      })
    );
  }
}

